// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/partner-livemap/PartnerLivemapEntry"),
  orderPrio: 80,
  iconType: "global",
  name: "partner-livemap"
}: AppType)
